import AcrylicPlatesListComponent from "src/components/features/superAdmin/acrylicPlatesListComponent";

const ListAcrylicPage = () => <AcrylicPlatesListComponent />;

export default ListAcrylicPage;
